import { post } from '@/utils/examMan/request'

export function fetchTree(data) {
  let obj = post('/api/learn/api/sys/dic/value/tree', data)
  // obj.then(res0=> {
  //   console.log('js里打印', res0)
  //   // qu_level  题难度 简单 一般 较难
  //   // qu_type 单选 多选...

  //   let white = ['qu_level', 'qu_type']

  //   if (white.indexOf(data.dicCode)<0) {
  //     return false
  //   }

  //   let constDictObj
  //   if (window.sessionStorage.constDictObj) {
  //     constDictObj = JSON.parse(window.sessionStorage.constDictObj)
  //   } else {
  //     constDictObj = {}
  //   }
  //   constDictObj[data.dicCode] = res0.data.data
  //   window.sessionStorage.constDictObj = JSON.stringify(constDictObj)
  // })
  return obj
}

export function saveValue(data) {
  return post('/api/learn/api/sys/dic/value/save', data)
}

export function deleteValue(data) {
  return post('/api/learn/api/sys/dic/value/delete', data)
}
